import { render, staticRenderFns } from "./Kanban.vue?vue&type=template&id=f560f204&scoped=true&lang=pug&"
import script from "./Kanban.vue?vue&type=script&lang=ts&"
export * from "./Kanban.vue?vue&type=script&lang=ts&"
import style0 from "./Kanban.vue?vue&type=style&index=0&id=f560f204&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f560f204",
  null
  
)

export default component.exports